import { ClaimCategoryEnum } from 'outshared-lib';

export enum DeployEnvironmentEnum {
    Production = 'production',
    Acceptance = 'acceptance',
    Development = 'development',
    Test = 'test',
    Demo = 'demo',
}

export interface EnabledClaimFunnelCategories {
    [ClaimCategoryEnum.Car]: boolean;
    [ClaimCategoryEnum.Pet]: boolean;
    [ClaimCategoryEnum.Travel]: boolean;
    [ClaimCategoryEnum.Home]: boolean;
    [ClaimCategoryEnum.Bicycle]: boolean;
    [ClaimCategoryEnum.Liability]: boolean;
    [ClaimCategoryEnum.Caravan]: boolean;
    [ClaimCategoryEnum.LegalAssistance]: boolean;
    [ClaimCategoryEnum.Moped]: boolean;
    [ClaimCategoryEnum.Motorcycle]: boolean;
}

export interface AppConfigInterface {
    blueconicUrl: string;
    cwv: boolean;
    cynolyticsUrl: string;
    gtmId: string;
    enabledFeatures: {
        claimFunnel: boolean;
        liveChat: boolean;
        mobileMenu: boolean;
        newClaimfunnel: boolean;
    };
    enabledClaimFunnelCategories: EnabledClaimFunnelCategories;
    deployEnvironment:
        | DeployEnvironmentEnum.Production
        | DeployEnvironmentEnum.Acceptance
        | DeployEnvironmentEnum.Development
        | DeployEnvironmentEnum.Test
        | DeployEnvironmentEnum.Demo;
}
